const wNumb = require("wnumb");
const nouislider = require("nouislider");

export class SliderFilter {
    constructor(selector, min, max, format, cur_min, cur_max) {
        this.slider = $(selector);
        this._min = min;
        this._max = max;

        this.initSliderPlugin(this.slider, this._min, this._max, format, cur_min, cur_max);
    }

    initSliderPlugin(slider, min, max, format, cur_min, cur_max) {
        if (slider.length) {
            nouislider.create(slider[0], {
                start: [cur_min, cur_max],
                connect: true,
                step: 100,
                tooltips: [wNumb(format), wNumb(format)],
                range: {
                    'min': min,
                    'max': max
                }
            });

            this.updateValues();
        }
    }

    filter(unit, dataAttr) {
        if (typeof this.lowValue == 'undefined') {
            this.lowValue = this._min;
        }

        if (typeof this.highValue == 'undefined') {
            this.highValue = this._max;
        }

        if (unit.data(dataAttr) >= parseInt(this.lowValue) && unit.data(dataAttr) <= parseInt(this.highValue)) {
            return true;
        }

        return false;
    }

    updateValues() {
        this.lowValue = this.slider.find('.noUi-handle-lower').attr('aria-valuetext');
        this.highValue = this.slider.find('.noUi-handle-upper').attr('aria-valuetext');
    }
}